import React, { useState, useEffect } from "react";
import { Link } from "lucide-react";
import { fetchTherapistBuilds, generateSingleLink } from "./api"; // ✅ updated import
import SingleLinkForm from "./SingleLinkForm";
import GeneratedLinkCard from "./GeneratedLinkCard";
import axios from "axios";
import Env from "../../../runtimeEnv";

const PresignLinkGenerator = () => {
  const [loading, setLoading] = useState(false);
  const [availableBuilds, setAvailableBuilds] = useState({});
  const [generatedLink, setGeneratedLink] = useState(null);
  const [copied, setCopied] = useState(null);
  const [message, setMessage] = useState(null);

  const [formData, setFormData] = useState({
    build_id: "",
    expiration_hours: 24,
    user_email: "",
    purpose: "",
  });

  useEffect(() => {
    const loadTherapistBuilds = async () => {
      const data = await fetchTherapistBuilds(); // ✅ fetch therapists + builds
      if (data.success) {
        // Convert API array → object for dropdown
        const therapistMap = {};
        data.therapists.forEach((t) => {
          therapistMap[t.therapist_id] = {
            name: t.name,
            description: t.description,
            url: t.url,
          };
        });

        setAvailableBuilds(therapistMap);

        // Set first therapist as default
        const firstTherapistId = Object.keys(therapistMap)[0];
        setFormData((prev) => ({ ...prev, build_id: firstTherapistId }));
      }
    };

    loadTherapistBuilds();
  }, []);

  const handleSingleLink = async () => {
    setLoading(true);
    setMessage(null);

    const data = await generateSingleLink(formData);

    if (data.success) {
      setGeneratedLink(data);
      setMessage({
        type: "success",
        text: "Link generated successfully!",
      });
    } else {
      setMessage({
        type: "error",
        text: data.error || "Failed to generate link.",
      });
    }

    setLoading(false);
  };

  const copyToClipboard = async (text, index = null) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(index !== null ? `bulk-${index}` : "single");
      setTimeout(() => setCopied(null), 2000);
    } catch {
      // Fallback for older browsers
    }
  };

  return (
    <div
      className="h-screen w-screen flex items-center justify-center"
      style={{
        background: "linear-gradient(to bottom, #24004266 40%, #4FCBE6 100%)",
      }}
    >
      <div className="max-w-4xl w-full mx-6 p-6 bg-white rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold text-gray-800 mb-8 flex items-center gap-3">
          <Link className="text-blue-600" />
          Presign Link Generator
        </h1>

        <SingleLinkForm
          formData={formData}
          setFormData={setFormData}
          availableBuilds={availableBuilds}
          loading={loading}
          onGenerate={handleSingleLink}
        />

        {generatedLink && (
          <GeneratedLinkCard
            generatedLink={generatedLink}
            copied={copied}
            copyToClipboard={copyToClipboard}
          />
        )}
      </div>
    </div>
  );
};

export default PresignLinkGenerator;
